import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unReadNotificationCount: 0,
  rubric: null,
  bundles: [],
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    setUnReadNotificationCount(state, action) {
      state.unReadNotificationCount = action.payload;
    },
    setRubric(state, action) {
      state.rubric = action.payload;
    },
    setBundles(state, action) {
      state.bundles = action.payload;
    },
  },
});

export const {
  setUnReadNotificationCount,
  setRubric,
  setBundles,
} = commonSlice.actions;

export default commonSlice.reducer;
